import { render, staticRenderFns } from "./ListComplain.vue?vue&type=template&id=0c1da2b0&scoped=true&"
import script from "./ListComplain.vue?vue&type=script&lang=ts&"
export * from "./ListComplain.vue?vue&type=script&lang=ts&"
import style0 from "./ListComplain.vue?vue&type=style&index=0&id=0c1da2b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1da2b0",
  null
  
)

export default component.exports